module.exports = __webpack_public_path__ + "static/media/menuNumber.581fe8e4.svg";